// Needs to be in unsecure build.

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
